import { render, staticRenderFns } from "./PersonnelDetail.vue?vue&type=template&id=11245938&scoped=true"
import script from "./PersonnelDetail.vue?vue&type=script&lang=js"
export * from "./PersonnelDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonnelDetail.vue?vue&type=style&index=0&id=11245938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11245938",
  null
  
)

export default component.exports